module.exports = __webpack_public_path__ + "img/step3.9a26600a.png";